module.exports = __webpack_public_path__ + "static/media/save-all.fb5deb73.svg";